import { configureStore } from "@reduxjs/toolkit";
import { env_configs } from "configs/env_configs";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { reducers } from "./reducers";

export const store = configureStore({
	reducer: reducers,
	devTools: env_configs.environment !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
